<section *ngIf="solutionIsSelected">
  <app-dealer-reply-step *ngFor="let solutionStep of solutionSteps; let index = index" [Index]="index"></app-dealer-reply-step>
</section>